/*
 * File: form-quick-table.ts
 * File Created: 2024-11-07 04:58:37
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-02 01:07:54
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { PropInnateSync } from "@root/core/vue-props";
import { UITag } from "@root/core/tags";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
@UITag.setDefault({
    uiBlockAutofill: true,
})
export default class FormQuickTable extends BaseFormComponent {
    @PropInnateSync("value", { type: Array, required: false })
    innateValue!: Array<any> | undefined;

    /// private helpers
    // required validation for number
    @makeRequiredValidator({
        validator: (o) => o.value != null && o.value.length > 0,
    })
    defaultRequired() {
        return undefined;
    }

    private mounted() {
        if (!this.meta.attr.tagMap["uiFormQuickTable"]) {
            this.console.warn(
                `<iv-form-quick-table> should use tag <@uiFormQuickTable>.`,
                this.meta,
            );
        }
    }
}
